import DualHorizontalBarCharts from "../ComplaintCharts/DualHorizontalBarChart.js";
import WaterMark from "../../../Components/WaterMark/WaterMark.jsx";
import { useQuery } from "@tanstack/react-query";
import { Loader } from "rsuite";
import { axInst } from "../../../Components/Login/Service";
import { useSelector } from "react-redux";

const primary_complaint = async (body) => {
  try {
    const res = await axInst.post("complaints/primary_complaint", body);
    // console.log(res.data);
    return res.data;
  } catch (error) {
    console.error(error);
  }
};

const processComplaintData = (response) => {
  // if (
  //   !response ||
  //   !response.primary_complaint_area ||
  //   !response.primary_complaint_area.product ||
  //   !response.primary_complaint_area.non_product
  // ) {
  //   return { productData: [], nonProductData: [] };
  // }

  const productData =
    response.primary_complaint_area.product.group_by.buckets.map((bucket) => ({
      name: bucket.key,
      value: bucket.doc_count,
    })) || [];

  const nonProductData =
    response.primary_complaint_area.non_product.group_by.buckets.map(
      (bucket) => ({
        name: bucket.key,
        value: bucket.doc_count,
      })
    ) || [];

  return { productData, nonProductData };
};

export const PrimaryAreas = () => {
  const { data, submitted } = useSelector((state) => state.filtersComplaint);

  const {
    data: primaryData,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["primary", submitted],
    queryFn: () => primary_complaint(data),
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
    cacheTime: 0,
    staleTime: 0,
  });

  const processedData = primaryData
    ? processComplaintData(primaryData)
    : { productData: [], nonProductData: [] };

  return (
    <div className="p-2 relative">
      {isFetching && (
        <div className="grid items-center justify-center w-full h-full">
          <Loader />
        </div>
      )}
      {isError && (
        <div className="grid items-center justify-center w-full h-full">
          <p>Error Occurred</p>
        </div>
      )}
      <WaterMark />

      <div>
        <DualHorizontalBarCharts
          productData={processedData.productData}
          nonProductData={processedData.nonProductData}
        />
      </div>
    </div>
  );
};
